require('../css/main.scss')
window.$ = window.jQuery = require('jquery')
require('bootstrap')
require('lightgallery')
require('./slick')
require('./nav-scroll')
require('./ken-burns')
require('../img/logo.svg')
require('../img/logo-linkomweb.png')
require('../img/pattern.png')
require('../img/insta.png')

$(document).ready(() => {
  $('.lightgallery').lightGallery({
    selector: '.gallery-item',
    download: false,
  })
})

$('body').on('mouseenter mouseleave', '.navbar-nav > .dropdown', function (e) {
  var _d = $(e.target).closest('.navbar-nav > .dropdown')
  _d.addClass('show')

  setTimeout(function () {
    _d[_d.is(':hover') ? 'addClass' : 'removeClass']('show')
  }, 300)
})

$(".label-container").click(function () {

  $header = $(this);

  $header.toggleClass("closed");

  //getting the next element
  $content = $header.next();
  //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
  $content.slideToggle(500, function () {


  });

});